export default __webpack_public_path__ + "static/media/4.7e62fca0.jpg";